import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { TASK_ACTIONS, TASK_TYPES } from '../../../util/hub-task-management/hub.constants'
import { generateHubTaskUrl } from '../../../util/hub-task-management/hub.utils'

export const SCHEDULER_ACTIONS = {
  // /hub/microsoft/offboarding/update
  OFFBOARDING: generateHubTaskUrl({
    tasktype: TASK_TYPES.offboarding,
    action: TASK_ACTIONS.update,
    root: '',
  }),
}

export const useSchedulerActionMessageMap = () => {
  const intl = useIntl()

  const actionMessageMap = useMemo(
    () => ({
      [SCHEDULER_ACTIONS.OFFBOARDING]: intl.formatMessage({ id: 'ENGAGE.OFFBOARD.OFFBOARDING' }),
    }),
    [intl],
  )

  return actionMessageMap
}
